// extracted by mini-css-extract-plugin
var _1 = "IconSpinner-moduleiconSpinner__Xu3dU IconNG-moduleIcon__AbXiV";
export { _1 as "iconSpinner" }
